import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-3 text-sm" }
const _hoisted_2 = { class: "text-custom-blue-50" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_4 = { class: "text-custom-blue-50" }
const _hoisted_5 = { class: "text-custom-blue-50" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = { class: "\n        p-4\n        rounded\n        border\n        dark:border-custom-black-300\n      " }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "text-custom-blue-50" }
const _hoisted_10 = { class: "align-middle -ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WalletButton = _resolveComponent("WalletButton")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: _ctx.isVisible,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    title: "Connect to a wallet",
    changeType: "wallet"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('byConnectingWallet')) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'terms-of-use' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('policies.termsOfUse')), 1),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'cookies-policy' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('policies.cookiesPolicy')), 1)
          ]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('and')) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'privacy-policy' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('policies.privacyPolicy')), 1),
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet) => {
        return (_openBlock(), _createBlock(_component_WalletButton, {
          wallet: wallet,
          key: wallet
        }, null, 8, ["wallet"]))
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t('newToEthereum')), 1),
        _createElementVNode("p", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t('setUpEthereumWallet')) + " ", 1),
          _createVNode(_component_BalLink, {
            noStyle: "",
            href: _ctx.EXTERNAL_LINKS.Ethereum.Wallets,
            external: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('learnMore')), 1),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_BalIcon, {
                  changeType: "wallet",
                  name: "arrow-up-right",
                  size: "sm"
                })
              ])
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}